import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { TRANSACTION_HISTORY } from "./apiRoutes";

interface UseGetTransactionHistoryProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTransactionHistory = async (data: any, communityId: string) =>
  await axiosAuth.post(`${TRANSACTION_HISTORY(communityId)}/grid`, data);

const useGetTransactionHistory = ({
  data,
  communityId,
  queryParams,
}: UseGetTransactionHistoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["transaction-history-logs", communityId, data],
    queryFn: () => getTransactionHistory(data, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTransactionHistory;
